/**
 * Shared helpers for the Connections Explorer.
 * All edges come from the documented network API — never speculative.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchGraph = (focus, kinds) =>
  axios.get(`${API}/network/graph`, {
    params: { ...(focus ? { focus } : {}), ...(kinds ? { kinds } : {}) },
  }).then((r) => r.data);

export const fetchEdge = (a, b) =>
  axios.get(`${API}/network/edge`, { params: { a, b } }).then((r) => r.data);

export const fetchPath = (from, to) =>
  axios.get(`${API}/network/path`, { params: { from, to, max_depth: 6 } })
    .then((r) => r.data);

export const searchEntities = (q) =>
  axios.get(`${API}/entities`, { params: { search: q, limit: 8 } })
    .then((r) => r.data.items || []);

export const KIND_META = {
  person:       { label: "Person",       color: "#D92D20" },
  organization: { label: "Organization", color: "#A68F5E" },
  operation:    { label: "Operation",    color: "#3FB950" },
};

export const groupOf = (n) => n.kind_group || "organization";

export const pathForEntity = (n) => {
  const g = groupOf(n);
  const prefix = g === "person" ? "people"
    : g === "operation" ? "operations" : "organizations";
  return `/${prefix}/${n.slug}`;
};

export const portraitSrc = (url) =>
  url ? `${process.env.REACT_APP_BACKEND_URL}${url}` : null;
